/* eslint-disable no-shadow */
import FirstAidBadge from '@/graphics/badges/FirstAidBadge.vue';
import CPRBadge from '@/graphics/badges/CPRBadge.vue';

interface QualificationsDetail {
  value: string;
  optionText: string;
}

interface PersonCareToggleTokenDatail {
  type: string;
  icon: any;
  iconWidth: number;
  iconHeight: number;
  iconType: string;
}

enum PersonCareQualificationsTypes {
  FIRST_AID_TRAINING = 'FIRST_AID_TRAINING',
  CPR_CERTIFIED = 'CPR_CERTIFIED',
}

enum PetCareQualificationsTypes {
  DOG_FIRST_AID_TRAINING = 'DOG_FIRST_AID_TRAINING',
  DOG_CPR_TRAINING = 'DOG_CPR_TRAINING',
  CAN_ADMINISTER_ORAL_MEDICATION = 'CAN_ADMINISTER_ORAL_MEDICATION',
  CAN_ADMINISTER_INJECTED_MEDICATION = 'CAN_ADMINISTER_INJECTED_MEDICATION',
}

type PersonCareQualificationsOptions = {
  [key in PersonCareQualificationsTypes]: QualificationsDetail;
};

type PetCareQualificationsOptions = {
  [key in PetCareQualificationsTypes]: QualificationsDetail;
};

const personCareQualificationsOptions: PersonCareQualificationsOptions = {
  [PersonCareQualificationsTypes.FIRST_AID_TRAINING]: {
    value: PersonCareQualificationsTypes.FIRST_AID_TRAINING,
    optionText: 'First Aid',
  },
  [PersonCareQualificationsTypes.CPR_CERTIFIED]: {
    value: PersonCareQualificationsTypes.CPR_CERTIFIED,
    optionText: 'CPR',
  },
};

const personCareQualificationsToggleTokenOptions: PersonCareToggleTokenDatail[] = [
  {
    type: PersonCareQualificationsTypes.FIRST_AID_TRAINING,
    icon: FirstAidBadge,
    iconWidth: 60,
    iconHeight: 60,
    iconType: 'badge',
  },
  {
    type: PersonCareQualificationsTypes.CPR_CERTIFIED,
    icon: CPRBadge,
    iconWidth: 60,
    iconHeight: 60,
    iconType: 'badge',
  },
];

const petCareQualificationsOptions: PetCareQualificationsOptions = {
  [PetCareQualificationsTypes.DOG_FIRST_AID_TRAINING]: {
    value: PetCareQualificationsTypes.DOG_FIRST_AID_TRAINING,
    optionText: 'Dog First Aid training',
  },
  [PetCareQualificationsTypes.DOG_CPR_TRAINING]: {
    value: PetCareQualificationsTypes.DOG_CPR_TRAINING,
    optionText: 'Dog CPR training',
  },
  [PetCareQualificationsTypes.CAN_ADMINISTER_ORAL_MEDICATION]: {
    value: PetCareQualificationsTypes.CAN_ADMINISTER_ORAL_MEDICATION,
    optionText: 'Can administer oral medication',
  },
  [PetCareQualificationsTypes.CAN_ADMINISTER_INJECTED_MEDICATION]: {
    value: PetCareQualificationsTypes.CAN_ADMINISTER_INJECTED_MEDICATION,
    optionText: 'Can administer injected medication',
  },
};

export { personCareQualificationsOptions, petCareQualificationsOptions, personCareQualificationsToggleTokenOptions };
